import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { matchRoutes } from 'react-router-config';
import loadBranchData from './loadBranchData';

class RouteDataLoader extends Component {
  componentDidUpdate(prevProps) {
    if (
      prevProps.location.pathname !== this.props.location.pathname ||
      prevProps.location.search !== this.props.location.search
    ) {
      this.load(this.props.location);
    }
  }

  load(location) {
    const { routes, store, client } = this.props;
    if (!routes || !store) return;

    const branch = matchRoutes(routes, location.pathname);
    loadBranchData(branch, {
      store,
      location,
      helpers: { client }
    });
  }

  render() {
    return this.props.children || null;
  }
}

export default withRouter(RouteDataLoader);
